const BUSINESS_TYPES = [
  {
    label: "Landbouwhandelaar / Boerderijwinkel",
    value: "Agricultural Merchant / Farm Store",
    id: "agricultural_merchant_farm_store",
  },
  {
    label: "Dierenasiel / Liefdadigheid",
    value: "Animal Shelter / Charity",
    id: "animal_shelter_charity",
  },
  {
    label: "Opfokbedrijf",
    value: "Backgrounder Lot",
    id: "backgrounder_lot",
  },
  {
    label: "Rundvleesproducent",
    value: "Beef Producer",
    id: "beef_producer",
  },
  { label: "Vleeskuikens", value: "Broilers", id: "broilers" },
  {
    label: "Inkoopgroep",
    value: "Buying Group",
    id: "buying_group",
  },
  {
    label: "Kalverproductie",
    value: "Calf Production",
    id: "calf_production",
  },
  {
    label: "Kalverboerderij/Ontwikkelaar",
    value: "Calf Ranch/Developer",
    id: "calf_ranch_developer",
  },
  { label: "Veehandelaar", value: "Cattle Buyer", id: "cattle_buyer" },
  {
    label: "Contractmester",
    value: "Contract Grower",
    id: "contract_grower",
  },
  { label: "Coöperatie", value: "Cooperative", id: "cooperative" },
  {
    label: "Hoofdkantoor",
    value: "Corporate Office",
    id: "corporate_office",
  },
  {
    label: "Moederkoehouderij",
    value: "Cow/Calf Operation",
    id: "cow_calf_operation",
  },
  {
    label: "Melkveehouderij",
    value: "Dairy Production",
    id: "dairy_production",
  },
  {
    label: "Distributeur / Agent",
    value: "Distributor / Agent",
    id: "distributor_agent",
  },
  { label: "Voederfabriek", value: "Feed Mill", id: "feed_mill" },
  { label: "Mestbedrijf", value: "Feedyard", id: "feedyard" },
  {
    label: "Kweker/Kwekerij",
    value: "Grower/Growyard",
    id: "grower_growyard",
  },
  { label: "Broederij", value: "Hatchery", id: "hatchery" },
  {
    label: "Vaarzenopfok",
    value: "Heifer Production",
    id: "heifer_production",
  },
  {
    label: "Leghennen Integratie",
    value: "Layer Integration",
    id: "layer_integration",
  },
  { label: "Leghennen", value: "Layers", id: "layers" },
  { label: "Media", value: "Media", id: "media" },
  {
    label: "Melkcoöperatie/Afnemer",
    value: "Milk Cooperative/Buyer",
    id: "milk_cooperative_buyer",
  },
  {
    label: "Gemengd/Andere Producent",
    value: "Mixed/Other Producer",
    id: "mixed_other_producer",
  },
  {
    label: "Voedingsstoffenleverancier",
    value: "Nutrient Supplier",
    id: "nutrient_supplier",
  },
  {
    label: "Verpakker/Verwerker",
    value: "Packer/Processor",
    id: "packer_processor",
  },
  {
    label: "Dierenwinkel",
    value: "Pet Retail Outlet",
    id: "pet_retail_outlet",
  },
  { label: "Apotheek", value: "Pharmacy", id: "pharmacy" },
  {
    label: "Pluimveefokker",
    value: "Poultry Breeder",
    id: "poultry_breeder",
  },
  {
    label: "Pluimvee-integrator",
    value: "Poultry Integrator",
    id: "poultry_integrator",
  },
  { label: "Schapenhouder", value: "Sheep Producer", id: "sheep_producer" },
  {
    label: "Opfokbedrijf",
    value: "Stocker Operation",
    id: "stocker_operation",
  },
  {
    label: "Veemarkt/Verkoopschuur",
    value: "Stockyard/Salebarn",
    id: "stockyard_salebarn",
  },
  { label: "Varkenshouder", value: "Swine Producer", id: "swine_producer" },
  { label: "Kalkoenen", value: "Turkeys", id: "turkeys" },
  {
    label: "Universiteit / Onderwijs",
    value: "University / Education",
    id: "university_education",
  },
  {
    label: "Dierenartspraktijk",
    value: "Veterinary Practice",
    id: "veterinary_practice",
  },
  {
    label: "Groothandel / Detailhandel",
    value: "Wholesaler / Retailer",
    id: "wholesaler_retailer",
  },
  { label: "Wolhandelaar", value: "Wool Buyer", id: "wool_buyer" },
];

const FIELDS = {
  common: {
    errors: {
      required: "Verplicht",
    },
  },
  salutation: {
    label: "Aanhef",
    placeholder: "Selecteer aanhef",
    errors: {
      required: "Aanhef is verplicht",
      invalid: "Selecteer een geldige aanhef",
    },
  },
  firstName: {
    label: "Voornaam",
    placeholder: "Jan",
    errors: {
      authenticatedNameUpdateTrial:
        "U bent ingelogd en uw naam kan niet worden gewijzigd.",
      required: "Voornaam is verplicht",
      minLength: "Voornaam moet minimaal 2 tekens bevatten",
      maxLength: "Voornaam mag maximaal 50 tekens bevatten",
    },
  },
  lastName: {
    label: "Achternaam",
    placeholder: "Janssen",
    errors: {
      authenticatedNameUpdateTrial:
        "U bent ingelogd en uw naam kan niet worden gewijzigd.",
      required: "Achternaam is verplicht",
      minLength: "Achternaam moet minimaal 2 tekens bevatten",
      maxLength: "Achternaam mag maximaal 50 tekens bevatten",
    },
  },
  email: {
    label: "E-mail",
    placeholder: "jan.janssen@voorbeeld.be",
    description:
      "Voer een persoonlijk e-mailadres in, geen gedeeld e-mailadres.",
    prefixWarningTitle: "Gedeelde mailbox gedetecteerd",
    prefixWarningDescription:
      "We raden aan een persoonlijk e-mailadres te gebruiken voor een betere gepersonaliseerde ervaring",
    errors: {
      authenticatedEmailUpdateTrial:
        "U bent ingelogd en uw e-mailadres kan niet worden gewijzigd.",
      required: "E-mail is verplicht",
      invalidEmail: "Voer een geldig e-mailadres in",
      emailAssociatedWithYourAccount:
        "Uw e-mailadres is gekoppeld aan uw account en kan niet worden gewijzigd.",
    },
  },
  confirmEmail: {
    label: "E-mail bevestigen",
    placeholder: "jan.janssen@voorbeeld.be",
    errors: {
      authenticatedEmailUpdateTrial:
        "U bent ingelogd en uw e-mailadres kan niet worden gewijzigd.",
      required: "E-mailbevestiging is verplicht",
      invalidEmail: "Voer een geldig e-mailadres in",
      emailMatchError: "E-mailadressen komen niet overeen",
    },
  },
  password: {
    label: "Wachtwoord",
    placeholder: "Voer uw wachtwoord in",
    errors: {
      required: "Wachtwoord is verplicht",
    },
  },
  confirmPassword: {
    label: "Wachtwoord bevestigen",
    placeholder: "Bevestig uw wachtwoord",
    errors: {
      required: "Wachtwoordbevestiging is verplicht",
      passwordMatchError: "Wachtwoorden komen niet overeen",
    },
  },
  addressLine1: {
    label: "Adresregel 1",
    placeholder: "Hoofdstraat 123",
    errors: {
      required: "Adresregel 1 is verplicht",
      minLength: "Adresregel 1 moet minimaal 5 tekens bevatten",
      maxLength: "Adresregel 1 mag maximaal 100 tekens bevatten",
    },
  },
  addressLine2: {
    label: "Adresregel 2",
    placeholder: "App 4B",
    errors: {
      required: "Adresregel 2 is verplicht",
      maxLength: "Adresregel 2 mag maximaal 100 tekens bevatten",
    },
  },
  city: {
    label: "Stad / Gemeente",
    placeholder: "Brussel",
    errors: {
      required: "Stad / Gemeente is verplicht",
      minLength: "Stad / Gemeente moet minimaal 2 tekens bevatten",
      maxLength: "Stad / Gemeente mag maximaal 50 tekens bevatten",
    },
  },
  country: {
    label: "Land",
    placeholder: "Selecteer land",
    errors: {
      required: "Land is verplicht",
      invalid: "Selecteer een geldig land",
    },
  },
  state: {
    label: "Provincie",
    placeholder: "Selecteer provincie",
    errors: {
      required: "Provincie is verplicht",
      invalid: "Selecteer een geldige provincie",
    },
  },
  jurisdiction: {
    label: "Rechtsgebied van licentie",
    placeholder: "Selecteer rechtsgebied van licentie",
    errors: {
      required: "Rechtsgebied van licentie is verplicht",
      invalid: "Selecteer een geldig rechtsgebied",
    },
  },
  zipCode: {
    label: "Postcode",
    placeholder: "1000",
    errors: {
      required: "Postcode is verplicht",
      invalid: "Voer een geldige postcode in",
    },
  },
  role: {
    label: "Rol",
    placeholder: "Selecteer uw rol",
    errors: {
      required: "Selecteer uw rol",
      invalid: "Selecteer een geldige rol",
    },
  },
  businessType: {
    label: "Bedrijfstype",
    placeholder: "Selecteer bedrijfstype",
    errors: {
      required: "Bedrijfstype is verplicht",
      invalid: "Selecteer een geldig bedrijfstype",
    },
  },
  businessName: {
    label: "Bedrijfsnaam",
    placeholder: "Voer bedrijfsnaam in",
    errors: {
      required: "Bedrijfsnaam is verplicht",
      minLength: "Bedrijfsnaam moet minimaal 2 tekens bevatten",
      maxLength: "Bedrijfsnaam mag maximaal 100 tekens bevatten",
    },
  },
  businessSearch: {
    label: "Bedrijfszoekactie:",
    addNewAccount: "Nieuw bedrijfsaccount toevoegen",
    canNotFindBusiness: "Kunt u uw bedrijf niet vinden?",
    guideline:
      "Voer uw postcode in en selecteer vervolgens uit de onderstaande lijst.",
    guidelineForNameSearch:
      "Voer de volledige bedrijfsnaam in en selecteer vervolgens uit de lijst.",
    placeholder: "Waar werkt u?",
    noResults: "Geen resultaten gevonden",
    searching: "Zoeken...",
    selectedBusinessHeading: "Geselecteerd bedrijf:",
    selectedBusinessNotCorrect: "Niet correct?",
    selectedBusinessTryAgain: "Opnieuw proberen",
    selectedBusinessDismiss: "Bedrijf verwijderen",
    resultsFound: {
      singular: "1 bedrijf gevonden",
      plural: "Meerdere bedrijven gevonden",
    },
    errors: {
      network:
        "We hebben problemen met de verbinding met de bedrijfszoeker. Probeer het later opnieuw.",
    },
  },
  explicitConsent: {
    label:
      "Door dit vakje aan te vinken ga ik ermee akkoord marketingcommunicatie van Elanco te ontvangen.",
    errors: {
      required: "Toestemming is vereist",
    },
  },
  explicitSmsConsent: {
    label:
      "Door dit vakje aan te vinken ga ik ermee akkoord marketingcommunicatie van Elanco te ontvangen via sms/tekstbericht.",
    errors: {
      required: "Toestemming voor sms is vereist",
    },
  },
  telephone: {
    label: "Persoonlijk telefoonnummer",
    placeholder: "Voer uw persoonlijk telefoonnummer in",
    dialCodeLabel: "Code",
    dialCodePlaceholder: "Zoek land…",
    errors: {
      invalid: "Voer een geldig telefoonnummer in.",
    },
  },
  businessTelephone: {
    label: "Zakelijk telefoonnummer",
    placeholder: "Voer uw zakelijk telefoonnummer in",
    dialCodeLabel: "Code",
    dialCodePlaceholder: "Zoek land…",
    errors: {
      invalid: "Voer een geldig telefoonnummer in.",
    },
  },
  professionalNumber: {
    label: "Professioneel nummer",
    placeholder: "1234567",
    errors: {
      required: "Voer een professioneel nummer in",
      maxLength: "Invoer overschrijdt de tekenlimiet",
    },
  },
  addressSearch: {
    errors: {
      required: "Dit veld is verplicht",
    },
  },
  businessSearchField: {
    errors: {
      required: "Dit veld is verplicht",
    },
  },
  checkbox: {
    errors: {
      required: "Dit veld is verplicht",
    },
  },
  checkboxGroup: {
    errors: {
      required: "Dit veld is verplicht",
    },
  },
  combobox: {
    errors: {
      required: "Dit veld is verplicht",
    },
  },
  datePicker: {
    errors: {
      required: "Dit veld is verplicht",
    },
  },
  dateRange: {
    errors: {
      required: "Dit veld is verplicht",
    },
  },
  dateTime: {
    errors: {
      required: "Dit veld is verplicht",
    },
  },
  emailField: {
    errors: {
      required: "Dit veld is verplicht",
    },
  },
  fileInput: {
    errors: {
      required: "Selecteer een bestand",
    },
  },
  number: {
    errors: {
      required: "Voer een getal in",
      minValue: "Voer een waarde in die hoger is dan het minimum",
      maxValue: "Voer een waarde in die lager is dan het maximum",
    },
  },
  passwordField: {
    errors: {
      required: "Dit veld is verplicht",
    },
  },
  rangeSlider: {
    errors: {
      required: "Dit veld is verplicht",
    },
  },
  select: {
    errors: {
      required: "Dit veld is verplicht",
    },
  },
  telephoneField: {
    errors: {
      required: "Voer alleen cijfers in",
      invalidTelephone: "Voer een geldig telefoonnummer in",
      invalidFormat: "Ongeldig nummerformaat",
    },
  },
  text: {
    errors: {
      required: "Gebruik alleen letters (A-Z), cijfers (0-9) en geen symbolen",
      maxLength: "Invoer overschrijdt de tekenlimiet",
      minLength: "Invoer moet minimaal 2 tekens bevatten",
    },
  },
  textarea: {
    characters: "tekens",
  },
  time: {
    errors: {
      required: "Dit veld is verplicht",
    },
  },
  form: {
    errors: {
      generic:
        "Er is een fout opgetreden bij het indienen van uw formulier. Probeer het opnieuw.",
      reportAnIssue: "Meld een probleem.",
      configuration: "Configuratiefout",
      noFormQuestionsAvailable: "Geen formuliervragen beschikbaar.",
      formComponentLoad:
        "Formuliercomponent kon niet worden geladen vanwege een niet-ondersteund veld.",
      code: "Code",
      type: "Type",
      missingRequiredFields:
        "In dit formulier ontbreken verplichte velden (e-mail en/of toestemming). Neem contact op met een beheerder om de formulierconfiguratie te corrigeren.",
    },
  },
};

const ROLES = [
  { value: "Academic", label: "Academicus", id: "academic" },
  {
    value: "Animal Welfare - Other",
    label: "Dierenwelzijn - Overig",
    id: "animal_welfare_other",
  },
  {
    value: "Animal Welfare - Retail Staff",
    label: "Dierenwelzijn - Winkelpersoneel",
    id: "animal_welfare_retail_staff",
  },
  {
    value: "Animal Welfare - Vet",
    label: "Dierenwelzijn - Dierenarts",
    id: "animal_welfare_vet",
  },
  {
    value: "Animal Welfare - Vet Nurse",
    label: "Dierenwelzijn - Dierenartsassistent",
    id: "animal_welfare_vet_nurse",
  },
  {
    value: "Animal Welfare - Volunteer",
    label: "Dierenwelzijn - Vrijwilliger",
    id: "animal_welfare_volunteer",
  },
  {
    value: "Beef / Feedlot Extension",
    label: "Rundvee / Mastbedrijf Voorlichting",
    id: "beef_feedlot_extension",
  },
  {
    value: "Beef Producer",
    label: "Rundvleesproducent",
    id: "beef_producer",
  },
  { value: "Breeder", label: "Fokker", id: "breeder" },
  {
    value: "Business Administrator / Receptionist",
    label: "Bedrijfsbeheerder / Receptionist",
    id: "business_administrator_receptionist",
  },
  {
    value: "Business Owner / Partner",
    label: "Bedrijfseigenaar / Partner",
    id: "business_owner_partner",
  },
  { value: "Clinic Buyer", label: "Clinic Buyer", id: "clinic_buyer" },
  {
    value: "Consulting Nutritionist",
    label: "Voedingsadviseur",
    id: "consulting_nutritionist",
  },
  {
    value: "Corporate Employee Non DVM",
    label: "Veterinair medewerker (niet-ziekenhuis)",
    id: "corporate_employee_non_dvm",
  },
  {
    value: "Dairy Producer",
    label: "Melkveehouder",
    id: "dairy_producer",
  },
  { value: "Distributor", label: "Distributeur", id: "distributor" },
  {
    value: "Distributor Rep, Field Based",
    label: "Distributievertegenwoordiger, Buitendienst",
    id: "distributor_rep_field_based",
  },
  {
    value: "Distributor Rep, Inside",
    label: "Distributievertegenwoordiger, Binnendienst",
    id: "distributor_rep_inside",
  },
  {
    value: "Educational Institution - Highschool Student",
    label: "Onderwijsinstelling - Middelbare scholier",
    id: "educational_institution_highschool_student",
  },
  {
    value: "Educational Institution - TAFE Student",
    label: "Onderwijsinstelling - Beroepsstudent",
    id: "educational_institution_tafe_student",
  },
  {
    value: "Educational Institution - University Student",
    label: "Onderwijsinstelling - Universiteitsstudent",
    id: "educational_institution_university_student",
  },
  { value: "Groomer", label: "Trimsalon medewerker", id: "groomer" },
  {
    value: "Marketing Associate",
    label: "Marketing Associate",
    id: "marketing_associate",
  },
  {
    value: "Medical / Clinic Director",
    label: "Medisch/Kliniek Directeur",
    id: "medical_clinic_director",
  },
  {
    value: "Nutrition / Feed Sales",
    label: "Voeding / Voederverkoop",
    id: "nutrition_feed_sales",
  },
  {
    value: "Nutritional Professional",
    label: "Voedingsprofessional",
    id: "nutritional_professional",
  },
  { value: "Nutritionist", label: "Voedingsdeskundige", id: "nutritionist" },
  {
    value: "Office / Practice Manager",
    label: "Kantoor/Praktijkmanager",
    id: "office_practice_manager",
  },
  { value: "OTC Retailer", label: "OTC Detailhandelaar", id: "otc_retailer" },
  { value: "Pharmacist", label: "Apotheker", id: "pharmacist" },
  {
    value: "Pharmacy - Staff",
    label: "Apotheek - Personeel",
    id: "pharmacy_staff",
  },
  { value: "Pig Producer", label: "Varkenshouder", id: "pig_producer" },
  {
    value: "Poultry Producer",
    label: "Pluimveehouder",
    id: "poultry_producer",
  },
  {
    value: "Practice Owner, Non DVM",
    label: "Praktijkeigenaar, Niet-DVM",
    id: "practice_owner_non_dvm",
  },
  {
    value: "Purchasing Agent",
    label: "Purchasing Agent",
    id: "purchasing_agent",
  },
  {
    value: "Receptionist / Client Service",
    label: "Receptionist/Klantenservice",
    id: "receptionist_client_service",
  },
  {
    value: "Reseller Store - Staff",
    label: "Wederverkoper - Personeel",
    id: "reseller_store_staff",
  },
  {
    value: "Producer - Mixed/Other",
    label: "Producent - Gemengd/Overig",
    id: "producer_mixed_other",
  },
  { value: "Retail Staff", label: "Retail Staff", id: "retail_staff" },
  {
    value: "Retail Store Manager",
    label: "Retail Store Manager",
    id: "retail_store_manager",
  },
  {
    value: "Retailer",
    label: "Detailhandelaar",
    id: "retailer",
  },
  {
    value: "Sheep Producer",
    label: "Schapenhouder",
    id: "sheep_producer",
  },
  { value: "SQP", label: "RAMA / SQP", id: "sqp" },
  { value: "Student", label: "Student", id: "student" },
  { value: "Student RAMA", label: "Student RAMA", id: "student_rama" },
  {
    value: "Tierarzt/ Tierärztin",
    label: "Dierenarts",
    id: "tierarzt_tierarztin",
  },
  { value: "Trainer", label: "Trainer", id: "trainer" },
  { value: "Veterinarian", label: "Dierenarts", id: "veterinarian" },
  {
    value: "Veterinarian, Practice Owner",
    label: "Dierenarts, Praktijkeigenaar",
    id: "veterinarian_practice_owner",
  },
  {
    value: "Veterinary Assistant",
    label: "Dierenartsassistent",
    id: "veterinary_assistant",
  },
  {
    value: "Veterinary Nurse",
    label: "Dierenartsassistent",
    id: "veterinary_nurse",
  },
  {
    value: "Veterinary Practice - Other",
    label: "Dierenartspraktijk - Overig",
    id: "veterinary_practice_other",
  },
  {
    value: "Veterinary Practice - Vet",
    label: "Dierenartspraktijk - Dierenarts",
    id: "veterinary_practice_vet",
  },
  {
    value: "Veterinary Practice - Vet Nurse",
    label: "Dierenartspraktijk - Dierenartsassistent",
    id: "veterinary_practice_vet_nurse",
  },
  {
    value: "Veterinary Specialist",
    label: "Veterinair Specialist",
    id: "veterinary_specialist",
  },
  {
    value: "Veterinary Student",
    label: "Diergeneeskunde Student",
    id: "veterinary_student",
  },
  {
    value: "Veterinary Surgeon",
    label: "Veterinair Chirurg",
    id: "veterinary_surgeon",
  },
  {
    value: "Veterinary Technician",
    label: "Veterinair Technicus",
    id: "veterinary_technician",
  },
  { value: "Wholesaler", label: "Groothandelaar", id: "wholesaler" },
];

const SALUTATIONS = [
  {
    label: "Dr.",
    value: "Dr.",
    id: "dr",
  },
  {
    label: "Dhr.",
    value: "M.",
    id: "m",
  },
  {
    label: "Juffrouw",
    value: "Miss",
    id: "miss",
  },
  {
    label: "Dhr.",
    value: "Mr.",
    id: "mr",
  },
  {
    label: "Mevr.",
    value: "Mrs.",
    id: "mrs",
  },
  {
    label: "Mevr.",
    value: "Ms.",
    id: "ms",
  },
  {
    label: "Mx.",
    value: "Mx.",
    id: "mx",
  },
  {
    label: "Professor",
    value: "Professor",
    id: "professor",
  },
];

export { BUSINESS_TYPES, FIELDS, ROLES, SALUTATIONS };
